<template>
  <div>
     
    
        <image-uploader
            :preview="false"
            :className="['fileinput', { 'fileinput--loaded': hasImage }]"
            capture="environment"
            :debug="0"
            doNotResize="gif"
            :autoRotate="true"
            outputFormat="blob"
            @input="setImage"
            :maxWidth="300" 
            :maxHeight="300" 
          >
          
            <label for="fileInput" slot="upload-label">
                <span class="icon" id="Supload" style="opacity:0">
                    <i class="fas fa-upload"/>
                </span>
            </label>
          
          </image-uploader>
    
  </div>
  
</template>
<style >
    #fileInput {
        display: none;
    }
    
</style>
<script>
import firebase from "firebase"

export default {
  props: ["pathFile"],
  data() {
    return {
      hasImage: false,
      imageUrl: null 
    }
  },
  methods: {
        setImage: function(output) {
            this.hasImage = true;
            var storageRef = firebase.storage().ref();
            var mountainsRef = storageRef.child(this.pathFile);
            this.$emit("start");
            
            mountainsRef.put(output).then(snapshot => {
                this.$emit("refresh");
            });
        }
        
    }
}
</script>
